import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { reactive, getCurrentInstance } from "vue";
import { setFormRequired } from "@ldos/shared-pc/src/util/miscUtils";
import { IStaffInfo } from "../interface";

export default /*#__PURE__*/_defineComponent({
  props: {
  terminal: String
},
  setup(__props, { expose }) {

const props = __props


const { proxy } = getCurrentInstance() as any;
const state: any = reactive({
  dialog: false,
  title: "",
  mode: "add",
  form: {},
  ruleForm: {
    shopName: [{ required: true, message: "请输入门店名称", trigger: "blur" }],
    shopCode: [{ required: true, message: "请输入门店代码", trigger: "blur" }],
    disabled: [
      { required: true, message: "请选择门店状态", trigger: "change" }
    ],
    tenantId: [{ required: true, message: "请选择租户", trigger: "blur" }],
    sealId: [{ required: true, message: "请输入印章ID", trigger: "change" }],
    companyAccount: [
      { required: true, message: "请输入公司易签宝账号ID", trigger: "change" }
    ]
  },
  storeStateList: [
    {
      value: false,
      label: "启用"
    },
    {
      value: true,
      label: "停用"
    }
  ],
  areaList: [], //区域下拉option
  tenantCode: "" //租户code ops端新建门店需要
});

const active = (res: any) => {
  state.title = res.title;
  state.mode = res.mode;
  state.form = { ...res.form };
  state.ruleForm = setFormRequired(
    state.ruleForm,
    state.mode === "detail" ? true : false
  );
  state.dialog = true;
  state.number = res.number;
  state.areaList = res.areaList || [];
  // ops端会有租户id
  if (res.form.tenantId) {
    state.tenantCode =
      proxy.pocket("TenantAll", {
        filter: (item: any) => item.value === res.form.tenantId
      })[0].extra.tenantCode || "";
  }
};

const tenantChange = (id: string) => {
  console.log(id, "---id---");
  // 门店区域 和门店code 跟随租户option 动态变换
  state.areaList =
    proxy.pocket("TenantAll", { filter: (item: any) => item.value === id })[0]
      .extra.areaList || "";
  state.tenantCode =
    proxy.pocket("TenantAll", { filter: (item: any) => item.value === id })[0]
      .extra.tenantCode || "";
};

const confimForm = (res: any) => {
  switch (state.mode) {
    case "add":
      addStore(res);
      break;
    case "edit":
      editStore(res);
      break;
    case "open":
      openStore(res);
      break;
    default:
      break;
  }
};
const addStore = async (data: any) => {
  data.current = 1;
  // console.error('props.terminal',props.terminal)
  if (props.terminal === "ops") {
    var api = "/ops/shop/add";
  } else {
    var api = "/mgr/shop/add";
  }
  const [res] = await proxy.$api.post(api, {
    ...data,
    tenantCode: state.tenantCode
  });
  proxy.$Message({
    type: "success",
    message: "添加成功"
  });
  state.dialog = false;
  proxy.$emit("optionSuccess", res);
};
const editStore = async (data: any) => {
  if (props.terminal === "ops") {
    var api = "/ops/shop/edit";
  } else {
    var api = "/mgr/shop/editNumber";
  }
  const [res] = await proxy.$api.post(api, {
    ...data,
    tenantCode: state.tenantCode
  });
  proxy.$Message({
    type: "success",
    message: "编辑成功"
  });
  state.dialog = false;
  proxy.$emit("optionSuccess", res);
};
const openStore = async (data: any) => {
  var api = "/mgr/shop/bindNumber";
  const [res] = await proxy.$api.post(api, {
    ...data,
    tenantCode: state.tenantCode
  });
  proxy.$Message({
    type: "success",
    message: "开通成功"
  });
  state.dialog = false;
  proxy.$emit("optionSuccess", res);
};
expose({
  active
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_mas_form_main = _resolveComponent("mas-form-main")!
  const _component_mas_modal = _resolveComponent("mas-modal")!

  return (_openBlock(), _createBlock(_component_mas_modal, {
    visible: _unref(state).dialog,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).dialog) = $event)),
    customFooterBtns: "",
    closeIcon: "",
    width: "450px",
    title: _unref(state).title
  }, {
    content: _withCtx(() => [
      _createVNode(_component_mas_form_main, {
        labelPosition: "right",
        form: _unref(state).form,
        ruleForm: _unref(state).ruleForm,
        disabled: _unref(state).mode === 'detail' ? true : false,
        defaultFormFooter: _unref(state).mode === 'detail' ? false : true,
        defaultFormFooterButton: ['confirm', 'cancel'],
        onConfim: confimForm,
        labelWidth: "100px",
        onCancel: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).dialog = false))
      }, {
        content: _withCtx((slotProps) => [
          _createVNode(_component_el_form_item, {
            label: "门店名称",
            prop: "shopName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                disabled: true,
                modelValue: slotProps.content.shopName,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.shopName) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "门店代码",
            prop: "shopCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                disabled: true,
                modelValue: slotProps.content.shopCode,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.shopCode) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "门店外部ID",
            prop: "externalId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                disabled: true,
                placeholder: "请输入门店外部ID",
                modelValue: slotProps.content.externalId,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.externalId) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "企微部门ID",
            prop: "wDepartmentId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                disabled: true,
                modelValue: slotProps.content.wDepartmentId,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.wDepartmentId) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "门店状态",
            prop: "state"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(slotProps.content.state === "EFFECTIVE" ? "启用" : slotProps.content.state
              == "DISABLED" ? "停用" : "未开通"), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "外呼号码",
            prop: "number"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: slotProps.content.number,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.number) = $event),
                placeholder: "多个请用英文逗号分隔"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "试驾电子签",
            prop: "testDriveEVisa"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "select",
                modelValue: slotProps.content.testDriveEVisa,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.testDriveEVisa) = $event),
                placeholder: "请选择试驾电子签",
                style: {"width":"280px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pocket('testDriveEVisa'), (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          (slotProps.content.testDriveEVisa === 'autoSign')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "印章ID",
                prop: "sealId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "请输入印章ID",
                    modelValue: slotProps.content.sealId,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.content.sealId) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (slotProps.content.testDriveEVisa === 'leadSign')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: "公司账号",
                prop: "companyAccount"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "请输入公司易签宝账号ID",
                    modelValue: slotProps.content.companyAccount,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.content.companyAccount) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["form", "ruleForm", "disabled", "defaultFormFooter"])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})